export default __webpack_public_path__ + "static/media/salad.a6b8557a.png";